import { AfterViewChecked, Component, OnDestroy, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Drawing } from '../../../../../viewmodels/idms/drawing';
import { DrawingPreviewGalleryService } from './drawing-preview-gallery.service';

@Component({
  selector: 'hb-drawing-preview-gallery',
  templateUrl: './drawing-preview-gallery.component.html',
  styleUrls: ['./drawing-preview-gallery.component.scss'],
})
export class DrawingPreviewGalleryComponent implements OnInit, OnDestroy, AfterViewChecked {
  drawings: Drawing[] = [];
  activeSlideIndex: number = -1;

  private loadedSlideIndexes: number[] = [];
  private unsubscribe: Subject<boolean> = new Subject();

  private requestedMediaItemDetailsId: string;
  isRequestedDrawingLoaded: boolean;

  get activeDrawingName(): string {
    if (this.drawings.length === 0 || this.activeSlideIndex < 0) {
      return '';
    }

    return this.drawings[this.activeSlideIndex].name;
  }

  constructor(public bsModalRef: BsModalRef, private galleryService: DrawingPreviewGalleryService) { }

  ngOnInit() {
    this.galleryService.drawingsLoaded.pipe(takeUntil(this.unsubscribe)).subscribe(drawings => {
      this.loadedSlideIndexes = [];
      this.drawings = drawings;
    });

    this.galleryService.drawingViewRequested.pipe(takeUntil(this.unsubscribe)).subscribe(mediaItemDetailsId => {
      this.requestedMediaItemDetailsId = mediaItemDetailsId;
      this.isRequestedDrawingLoaded = false;
      this.activeSlideIndex = this.drawings.findIndex(drawing => drawing.mediaItemDetailsId === mediaItemDetailsId);
    });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  ngAfterViewChecked() {
    this.hideNgxCarouselNavigation();
  }

  hideNgxCarouselNavigation() {
    const previousElements = document.getElementsByClassName('carousel-control-prev');
    const nextElements = document.getElementsByClassName('carousel-control-next');

    if (previousElements.length === 0 || nextElements.length === 0) {
      return;
    }

    (previousElements[0] as HTMLElement).style.display = 'none';
    (nextElements[0] as HTMLElement).style.display = 'none';
  }

  onActiveSlideChanged(newActiveSlideIndex: number) {
    if (this.loadedSlideIndexes.findIndex(slideIndex => slideIndex === newActiveSlideIndex) === -1) {
      this.loadedSlideIndexes.push(newActiveSlideIndex);
    }
  }

  isLoadableSlide(slideIndex: number) {
    return slideIndex === this.activeSlideIndex || this.loadedSlideIndexes.findIndex(index => index === slideIndex) !== -1;
  }

  isLoadableAdjacentSlide(slideIndex: number) {
    if (!this.isRequestedDrawingLoaded) {
      return false;
    }

    const isLeftSlide = (slideIndex === this.activeSlideIndex - 1) || (this.activeSlideIndex === 0 && (slideIndex === this.drawings.length - 1));
    const isRightSlide = (slideIndex === this.activeSlideIndex + 1) || ((this.activeSlideIndex === this.drawings.length - 1) && slideIndex === 0);

    return isLeftSlide || isRightSlide;
  }

  onPreviewLoaded(isLoaded: boolean, mediaItemDetailsId: string) {
    if (isLoaded && mediaItemDetailsId === this.requestedMediaItemDetailsId) {
      this.isRequestedDrawingLoaded = true;
    }
  }

  moveLeft() {
    if (this.drawings.length === 0) {
      return;
    }

    if (this.activeSlideIndex === 0) {
      this.activeSlideIndex = this.drawings.length - 1;
    } else {
      this.activeSlideIndex = this.activeSlideIndex - 1;
    }
  }

  moveRight() {
    if (this.drawings.length === 0) {
      return;
    }

    if (this.activeSlideIndex === this.drawings.length - 1) {
      this.activeSlideIndex = 0;
    } else {
      this.activeSlideIndex = this.activeSlideIndex + 1;
    }
  }

  containsMultipleDrawings(): boolean {
    return this.drawings && this.drawings.length > 0;
  }
}
